'use client';

import { c as _c } from "react/compiler-runtime";
import { Card } from '@achra/ui/card';
import { type ReactNode, Suspense } from 'react';
import { BreakdownChartFilterSkeleton } from './skeleton';
import { TitleFilterSection } from './title-filter-section';
interface BreakdownChartCardProps {
  children: ReactNode;
}
function BreakdownChartCard(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Suspense fallback={<BreakdownChartFilterSkeleton />}><TitleFilterSection /></Suspense>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Card className="bg-popover flex w-full flex-col gap-4 border-none p-2 pb-4 shadow-xs md:p-4 lg:p-6">{t1}{children}</Card>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export { BreakdownChartCard };